import ButtonCollapsed from "@/components/header/button-collapsed";
import ThemeToggle from "@/components/header/theme-toggle";
import UserPopover from "@/components/header/user-popover";
import Image from "next/image";
import Link from "next/link";
import React from "react";

export default function Header() {
  return (
    <header className="border-white/12 sticky top-0 z-20 flex h-[58px] items-center justify-between border-b bg-[linear-gradient(90deg,#2b437f_0%,#31508c_40%,#2f4a82_100%)] px-4 text-white shadow-overlay lg:px-8">
      <ButtonCollapsed />
      <div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center gap-3 lg:static lg:translate-x-0 lg:translate-y-0 lg:gap-4">
        <Link href="/" className="transition duration-300 hover:opacity-95">
          <Image
            src="/images/logo.png"
            alt={process.env.NEXT_PUBLIC_APP_NAME ?? ""}
            className="mx-auto size-[42px] brightness-0 invert filter lg:size-[46px]"
            width={46}
            height={46}
            priority
          />
        </Link>
        <p className="hidden select-none text-lg font-semibold capitalize tracking-tight text-white/95 sm:block lg:text-[18px]">
          {process.env.NEXT_PUBLIC_APP_NAME}
        </p>
      </div>

      <div className="flex h-full items-center gap-2 lg:gap-3">
        <ThemeToggle />
        <UserPopover />
      </div>
    </header>
  );
}
